export default __webpack_public_path__ + "static/char-s-43-ja-8993258abe47adbd1eaad5d256d04509.webp";